import type { ReactNode } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { getPrograms } from '../../../services/ProgramService';
import { SelectComponent } from '../../core/SelectComponent/SelectComponent';
import { signupProgramStepStyles } from './SignupProgramStep.styles';

interface SignupProgramStepProps {
  program: string;
  isWorking: boolean;
  isTokenVisible: boolean;
  hasConfirmedSubscription: boolean;
  subscriptionTokenControls: ReactNode;
  actionError: string;
  onProgramChange: (program: string) => void;
  onTokenVisibilityChange: (isVisible: boolean) => void;
  onContinue: () => void;
}

const curriculumOptions = getPrograms();

export function SignupProgramStep({program, isWorking, isTokenVisible, hasConfirmedSubscription, subscriptionTokenControls, actionError, onProgramChange, onTokenVisibilityChange, onContinue}: SignupProgramStepProps) {
  const theme = useTheme();

  return (
    <Box component="section" aria-labelledby="program-heading" sx={signupProgramStepStyles.stepContent()}>
      <Box sx={signupProgramStepStyles.sectionHeadingRow()}>
        <Typography id="program-heading" component="h2" sx={signupProgramStepStyles.sectionHeading()}>Choose your program</Typography>
        {!hasConfirmedSubscription && <Button type="button" variant="text" aria-expanded={isTokenVisible} aria-controls="subscription-token-panel" onClick={() => onTokenVisibilityChange(!isTokenVisible)} sx={signupProgramStepStyles.tokenToggle(theme)}>Have a subscription token?</Button>}
      </Box>
      {isTokenVisible && !hasConfirmedSubscription && subscriptionTokenControls}
      {actionError && <Typography role="alert" sx={signupProgramStepStyles.actionError(theme)}>{actionError}</Typography>}
      {hasConfirmedSubscription ? subscriptionTokenControls : (
        <>
          <Box sx={signupProgramStepStyles.fieldGroup()}>
            <SelectComponent<string> label="Program" placeholder="Select your Program" fontSize={signupProgramStepStyles.selectFontSize} options={curriculumOptions.map((option) => ({id: option.value, name: option.label}))} value={program} onChange={onProgramChange} />
          </Box>
          <Button type="button" variant="contained" disableElevation disabled={!program || isWorking} onClick={onContinue} sx={signupProgramStepStyles.continueButton(theme)}>Continue</Button>
        </>
      )}
    </Box>
  );
}
